import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteHeader } from "@/components/sections/SiteHeader";
import { Hero } from "@/components/sections/Hero";
import { Problem } from "@/components/sections/Problem";
import { WhyTracking } from "@/components/sections/WhyTracking";
import { LiveDashboard } from "@/components/sections/LiveDashboard";
import { MilestoneVisibility } from "@/components/sections/MilestoneVisibility";
import { SmartAlerts } from "@/components/sections/SmartAlerts";
import { ConnectedWorkspace } from "@/components/sections/ConnectedWorkspace";
import { BusinessOutcomes } from "@/components/sections/BusinessOutcomes";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { SiteFooter } from "@/components/sections/SiteFooter";

const Landing = () => (
  <div className="min-h-screen bg-background text-foreground">
    <SiteHeader />
    <main>
      <Hero />
      <Problem />
      <WhyTracking />
      <LiveDashboard />
      <MilestoneVisibility />
      <SmartAlerts />
      <ConnectedWorkspace />
      <BusinessOutcomes />
      <FAQ />
      <FinalCTA />
    </main>
    <SiteFooter />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
